import React, { useEffect, useState } from 'react';
import { ConfigProvider, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { fourDays } from '../utils';
import frFR from 'antd/locale/fr_FR';
import 'dayjs/locale/fr';
dayjs.locale('fr');

const DateTimeSelector = ({ 
  setMoveNavigator,
  draggableLinePosition,
  setDraggableLinePosition,
  startDatePrediction,
  endDatePrediction,
  ref11,
}) => {
  const [selectedDateTime, setSelectedDateTime] = useState(dayjs(startDatePrediction));


  useEffect(() => {
    if (draggableLinePosition) {
      const newDateTime = dayjs(draggableLinePosition);
      setSelectedDateTime(newDateTime);
    }
  }, [draggableLinePosition]);

  const handleChange = (value) => {
    if (value) {
      const fixeMinutesValue = value.minute(0).second(0);
      const timestamp = fixeMinutesValue.valueOf();
      setSelectedDateTime(fixeMinutesValue);

      const fourDaysMs = fourDays * 1000;
      setDraggableLinePosition(timestamp - fourDaysMs);
      setMoveNavigator(true);
    } else {
      setSelectedDateTime(null);
    }
  };

  const disabledDate = (current) => {
    if (!current) return false;
    return current.isBefore(dayjs(startDatePrediction), 'minute') || current.isAfter(dayjs(endDatePrediction), 'minute');
  };

  const disabledTime = (currentDate) => {
    if (!currentDate) return {};
    const start = dayjs(startDatePrediction);
    const end = dayjs(endDatePrediction);

    const isStartDay = currentDate.isSame(start, 'day');
    const isEndDay = currentDate.isSame(end, 'day');

    return {
      disabledHours: () => {
        const hours = [];
        if (isStartDay) {
          for (let i = 0; i < start.hour(); i++) hours.push(i);
        }
        if (isEndDay) {
          for (let i = end.hour() + 1; i < 24; i++) hours.push(i);
        }
        return hours;
      },
      disabledMinutes: () => {
        const minutes = [];
        for (let i = 1; i < 60; i++) minutes.push(i);
        return minutes;
      },
    };
  };

  return (
    <section className="dateTimeSelector">
      <div ref={ref11}>
      <ConfigProvider locale={frFR}>
        <DatePicker
          showTime={{
            format: 'HH:mm',
            disabledTime: (currentDate) => disabledTime(currentDate),
            defaultValue: dayjs(startDatePrediction).minute(0).second(0),
          }}
          value={selectedDateTime}
          format="YYYY-MM-DD HH:mm"
          disabledDate={disabledDate}
          onChange={handleChange}
          placeholder="Date prédiction"
        />
        </ConfigProvider>
      </div>
    </section>
  );
};

export default DateTimeSelector;
